// eslint-disable-next-line import/no-import-module-exports
import React from 'react';

const ajax = require('component-ajax');

class LoadingComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      loading: true,
    };

    this.dataUrl = null;
    this.requestType = 'GET';
    this.requestParams = null;
  }

  componentDidMount() {
    this.fetchData(this.requestParams);
  }

  onDataLoad(data) {
    this.setState({ loading: false, ...data });
  }

  fetchData(params) {
    this.setState({ loading: true });

    ajax({
      url: this.dataUrl,
      data: params || null,
      type: this.requestType,
      success: (data) => this.onDataLoad(data),
    });
  }

  // eslint-disable-next-line react/no-unused-class-component-methods
  shouldRender() {
    // eslint-disable-next-line react/destructuring-assignment
    return !this.state.loading;
  }
}

module.exports = LoadingComponent;
